import { useSearch } from "@tanstack/react-router";
import { TemplateStudio } from "@/components/scheduled-briefings/template-studio/TemplateStudio";
import { TemplateLayoutLoadStatus } from "@/components/scheduled-briefings/templates/TemplateLayoutLoadStatus";
import { useTemplateLayout } from "@/lib/template-studio/repository/useTemplateLayout";

const DuplicateTemplateStudio = ({ templateId }: { templateId: string }) => {
  const { template, error, isRetryable, retry } = useTemplateLayout(templateId);

  return template ? (
    <TemplateStudio mode="duplicate" template={template} />
  ) : (
    <TemplateLayoutLoadStatus
      error={error}
      isRetryable={isRetryable}
      retry={retry}
    />
  );
};

/** Serves `templates/create`; `?duplicateFrom=<id>` seeds a copy of that template. */
const TemplateStudioCreateRoute = () => {
  const { duplicateFrom } = useSearch({ strict: false });

  return duplicateFrom === undefined ? (
    <TemplateStudio />
  ) : (
    <DuplicateTemplateStudio key={duplicateFrom} templateId={duplicateFrom} />
  );
};

export default TemplateStudioCreateRoute;
